// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__dl_x1","icon":"holding-image_icon__Ub_aO"};